import { ajaxActions } from "./AjaxActions";

const BASE_URL = process.env.REACT_APP_SHARE_SERVICE_URL;
const CANCELLATION_PERIOD_MS = 14 * 24 * 60 * 60 * 1000;

const reopenQuestionnaire = async (id: string): Promise<boolean> => {
  const resp = await ajaxActions.patch(`${BASE_URL}/formSubmissions/${id}`, {
    submitted: null,
  });
  return resp.ok;
};

const cancelFormSubmission = (
  id: string,
  reasonOfCancellation?: string
): Promise<Response> =>
  ajaxActions.patch(
    `${BASE_URL}/formSubmissions/${id}/cancel`,
    reasonOfCancellation || undefined
  );

const isCancellationAllowed = (
  lastSubmitted?: string | number | Date | null
): boolean => {
  if (!lastSubmitted) {
    return false;
  }

  const submittedAt = new Date(lastSubmitted).getTime();
  return (
    !Number.isNaN(submittedAt) &&
    Date.now() <= submittedAt + CANCELLATION_PERIOD_MS
  );
};

const isValuePresent = (key: string, values: Record<string, boolean>) =>
  Object.keys(values).includes(key) && values[key] === true;

export const FormSubmissionS = {
  reopenQuestionnaire,
  cancelFormSubmission,
  isCancellationAllowed,
  isValuePresent,
};
